import React, { useCallback, useState, useEffect } from "react";
import { Col, Row, Table } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./ReportClassTable.css";
import "./SencoStudentsResultsTable.css";
import LiteracyObservationsModal from "./LiteracyObservationsModal";
import ReadingScoreNotesModal from "./ReadingScoreNotesModal";
import AdditionalNeedsModal from "./AdditionalNeedsModal";
import SupportPlanModal from "./SupportPlanModal";
import ConfirmationModal from "./ConfirmationModal";
import SetEalModal from "./SetEalModal";
import SetSetModal from "./SetSetModal";
import SetAttendanceAffectingScoresModal from "./SetAttendanceAffectingScoresModal";

import HandoverTableRow from "./HandoverTableRow";
import NoteModal from "./NoteModal";
import SenWatchlistModal from "./SenWatchlistModal";
import { getNotes, getWatchlist, updateStudent } from "../services/APIClient";

function HandoverClassTable(props) {
  const {
    showAtRiskOnly,
    setShowAtRiskOnly,
    teachers,
    teacherid,
    studentsReadingScore,
    setShowSortedData,
    classDetails,
    additionalRoles,
    getReport,
    upsertReport,
    noteType = "ClassroomHandover",
    ealManagedByReport = false,
  } = props;

  const dummyHeaderArray = [
    "Overall Score Observations",
    "Literacy Observations",
    "AEN Observations",
    "Classroom Support Observations",
    "EAL",
    "Watchlist",
    "Attendance Affecting Scores",
  ];

  const [showLiteracyModal, setShowLiteracyModal] = useState(false);
  const [showReadingScoreModal, setShowReadingScoreModal] = useState(false);
  const [showAdditionalNeedsModal, setShowAdditionalNeedsModal] = useState(false);
  const [showSupportPlanModal, setShowSupportPlanModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showEalModal, setShowEalModal] = useState(false);
  const [showSetModal, setShowSetModal] = useState(false);
  const [showAttendanceAffectingScoresModal, setShowAttendanceAffectingScoresModal] = useState(false);
  const [currentStudentName, setCurrentStudentName] = useState("");
  const [currentStudentId, setCurrentStudentId] = useState("");

  const [readingScoreNotes, setReadingScoreNotes] = useState([]);
  const [literacyObservations, setLiteracyObservations] = useState("");
  const [additionalNeeds, setAdditionalNeeds] = useState([]);
  const [supportPlan, setSupportPlan] = useState([]);
  const [eal, setEal] = useState(false);
  const [set, setSet] = useState(false);
  const [attendanceAffectingScores, setAttendanceAffectingScores] = useState(false);
  const [students, setStudents] = useState();

  const [newEalState, setNewEalState] = useState(false);
  const [newSetState, setNewSetState] = useState(false);
  const [newAttendanceState, setNewAttendanceState] = useState(false);

  const [saveClicked, setSaveClicked] = useState(false);

  const [sortCriteria, setSortCriteria] = useState({ field: "name", order: "asc" });
  const [sortedData, setSortedData] = useState([]);
  console.log(sortedData, "SORTED DATA");

  const [selectedFilter, setSelectedFilter] = useState("all");

  const [watchlistStatuses, setWatchlistStatuses] = useState({});
  const [showWatchlistModal, setShowWatchlistModal] = useState(false);
  const [watchlistModalAction, setWatchlistModalAction] = useState(null);
  const [watchlistModalStudent, setWatchlistModalStudent] = useState(null);
  const classId = classDetails?.id;

  const [hasClassNotes, setHasClassNotes] = useState(false);

  const fetchClassNotes = useCallback(async () => {
    if (!classId) return;
    try {
      const filterNoteType = noteType === "ClassroomObservation" ? noteType : null;
      const res = await getNotes("class", classId, filterNoteType);
      setHasClassNotes((res.data || []).length > 0);
    } catch (err) {
      console.error("Error fetching class notes:", err);
      setHasClassNotes(false);
    }
  }, [classId, noteType]);

  useEffect(() => {
    fetchClassNotes();
  }, [fetchClassNotes]);

  const handleShowLiteracyModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowLiteracyModal(true);
  };

  const handleShowReadingScoreModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowReadingScoreModal(true);
  };

  const handleShowAdditionalNeedsModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowAdditionalNeedsModal(true);
  };

  const handleShowSupportPlanModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSupportPlanModal(true);
  };

  const handleShowAttendanceAffectingScoresModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowAttendanceAffectingScoresModal(true);
  };

  const handleShowESetModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSetModal(true);
  };

  const handleShowEalModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowEalModal(true);
  };

  const handleShowConfirmationModalEAL = (studentName, studentId, newEal) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setNewEalState(newEal);
    setShowConfirmationModal(true);
  };

  const handleShowConfirmationModalSET = (studentName, studentId, newSet) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setNewSetState(newSet);
    setShowConfirmationModal(true);
  };

  const handleShowConfirmationModalAttendance = (studentName, studentId, newAttendance) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setNewAttendanceState(newAttendance);
    setShowConfirmationModal(true);
  };

  useEffect(() => {
    console.log("Current eal state:", eal);
  }, [eal]);

  const handleCloseLiteracyModal = () => setShowLiteracyModal(false);
  const handleCloseReadingScoreModal = () => setShowReadingScoreModal(false);
  const handleCloseAdditionalNeedsModal = () => setShowAdditionalNeedsModal(false);
  const handleCloseSupportPlanModal = () => setShowSupportPlanModal(false);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);
  const handleCloseEalModal = () => setShowEalModal(false);
  const handleCloseSetModal = () => setShowSetModal(false);
  const handleCloseAttendanceAffectingScoresModal = () => setShowAttendanceAffectingScoresModal(false);

  const [lastSavedStudentId, setLastSavedStudentId] = useState();

  useEffect(() => {
    console.log(lastSavedStudentId, "LAST STUDENT");
  }, [lastSavedStudentId]);

  const initialState = {
    readingScoreNotes: [],
    literacyObservations: "",
    additionalNeeds: [],
    supportPlan: [],
    eal: false,
    set: false,
    attendanceAffectingScores: false,
  };

  const resetStateVariables = () => {
    setReadingScoreNotes(initialState.readingScoreNotes);
    setLiteracyObservations(initialState.literacyObservations);
    setAdditionalNeeds(initialState.additionalNeeds);
    setSupportPlan(initialState.supportPlan);
    setEal(initialState.eal);
    setSet(initialState.set);
    setAttendanceAffectingScores(initialState.attendanceAffectingScores);
  };

  const handleSaveChanges = () => {
    const reportData = {
      studentid: currentStudentId,
      teacherid: teacherid,
      readingscorenotes: readingScoreNotes,
      literacyobservations: literacyObservations,
      additionalneeds: additionalNeeds,
      supportplan: supportPlan,
      eal: eal,
      set: set,
      attendanceaffectingscores: attendanceAffectingScores,
    };

    console.log("Saving report data:", reportData);

    if (currentStudentId) {
      setLastSavedStudentId(currentStudentId);
      upsertReport(reportData)
        .then((response) => {
          console.log("Upsert Report Success:", response);
        })
        .catch((error) => console.error("Error:", error));
    } else {
      console.error("Error: No student selected.");
    }
  };

  const handleConfirmChange = () => {
    console.log("Confirmation received, saving changes");
    handleSaveChanges();
    handleCloseConfirmationModal();
  };

  const handleFilterChange = (e) => {
    setSelectedFilter(e.target.value);
  };

  const fetchWatchlistStatuses = async () => {
    try {
      const watchlist = await getWatchlist(false);
      const statusMap = {};
      watchlist.forEach((entry) => {
        statusMap[entry.studentid] = true;
      });
      setWatchlistStatuses(statusMap);
    } catch (error) {
      console.error("Error fetching watchlist statuses:", error);
    }
  };

  useEffect(() => {
    fetchWatchlistStatuses();
  }, []);

  const handleSenToggle = (studentId, currentSenState) => {
    const student = sortedData.find((s) => s.id === studentId);
    setWatchlistModalStudent(student);
    setWatchlistModalAction(currentSenState ? "remove" : "add");
    setShowWatchlistModal(true);
  };

  const handleWatchlistSuccess = async () => {
    await fetchWatchlistStatuses();
    if (watchlistModalStudent) {
      const newSenState = watchlistModalAction === "add";
      try {
        await updateStudent(watchlistModalStudent.id, { sen: newSenState });
        setSortedData((prev) =>
          prev.map((s) => s.id === watchlistModalStudent.id ? { ...s, sen: newSenState } : s)
        );
      } catch (error) {
        console.error("Error syncing student sen flag:", error);
      }
    }
  };

  useEffect(() => {
    if (currentStudentId) {
      setSaveClicked(false);
      getReport(currentStudentId)
        .then((response) => {
          console.log("Report Data:", response);
          if (response && response.readingscorenotes !== undefined) setReadingScoreNotes(response.readingscorenotes);
          if (response && response.literacyobservations !== undefined) setLiteracyObservations(response.literacyobservations);
          if (response && response.additionalneeds !== undefined) setAdditionalNeeds(response.additionalneeds);
          if (response && response.supportplan !== undefined) setSupportPlan(response.supportplan);
          if (response && response.eal !== undefined) setEal(response.eal);
          if (response && response.set !== undefined) setSet(response.set);
          if (response && response.attendanceaffectingscores !== undefined) setAttendanceAffectingScores(response.attendanceaffectingscores);
        })
        .catch((error) => console.error("Error fetching report:", error));
    }
  }, [currentStudentId, saveClicked]);

  useEffect(() => {
    const sortedStudents = sortStudents(studentsReadingScore, sortCriteria);
    setSortedData(sortedStudents);
  }, [studentsReadingScore, sortCriteria]);

  const sortStudents = (students, criteria) => {
    return [...students].sort((a, b) => {
      if (criteria.field === "name") {
        return criteria.order === "asc"
          ? a.name?.localeCompare(b.name)
          : b.name?.localeCompare(a.name);
      } else if (criteria.field === "readingScore") {
        let scoreA = a.readingScore === "No completed tasks" || a.readingScore === "NA" ? -1 : Number(a.readingScore);
        let scoreB = b.readingScore === "No completed tasks" || b.readingScore === "NA" ? -1 : Number(b.readingScore);
        return criteria.order === "asc" ? scoreA - scoreB : scoreB - scoreA;
      }
    });
  };

  const handleSortChange = (field) => {
    setSortCriteria((prev) => ({
      field,
      order: prev.field === field && prev.order === "asc" ? "desc" : "asc",
    }));
  };

  const getReadingScoreClass = (score) => {
    if (score === 0 || (score > 0 && score <= 20)) return "low-color";
    if (score > 20 && score <= 40) return "med-color";
    if (score > 40 && score <= 80) return "noRisk-color";
    if (score >= 81 && score <= 100) return "high-color";
    return "";
  };

  const getLatestIndividualScore = (student) => {
    const scores = student?.assessmentScores || {};
    const pick = (v) => (v === null || v === undefined ? null : Number(v));
    const eoy = pick(scores.endOfYear);
    if (eoy !== null && !Number.isNaN(eoy)) return eoy;
    const mid = pick(scores.midpoint);
    if (mid !== null && !Number.isNaN(mid)) return mid;
    const base = pick(scores.baseline);
    if (base !== null && !Number.isNaN(base)) return base;
    return null;
  };

  const handleSaveSuccess = (studentId) => {
    console.log("Save successful for student:", studentId);
    setSaveClicked(Date.now());
  };

  console.log(sortedData, "SORTED DATA IN TABLE");

  const handlePrintAllNotes = async () => {
    const formatNote = (n, teachersList) => {
      const teacher = teachersList.find((t) => t.id === n.teacherid);
      const teacherName = teacher?.name || 'Unknown';
      const dateStr = new Date(n.date_created).toLocaleString('en-IE', {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Europe/Dublin',
      });
      return `
        <div style="margin-bottom:12px; padding:10px 12px; border-left:3px solid #1a56db; background:#f8f9fa; border-radius:4px;">
          <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:6px;">
            <!-- <span style="font-size:11px; font-weight:bold; background:#1a56db; color:white; padding:2px 8px; border-radius:4px;">${n.note_type}</span> -->
            <span style="font-size:11px; color:#666;">${teacherName} &bull; ${dateStr}</span>
          </div>
          <div style="font-size:13px; color:#333; white-space:pre-wrap;">${n.note_text}</div>
        </div>`;
    };
    const [classNotesRes, ...studentNotesRes] = await Promise.all([
      getNotes('class', classDetails.id, 'ClassroomHandover'),
      ...(studentsReadingScore || []).map((s) => getNotes('student', s.id, 'ClassroomHandover').then((r) => ({ name: s.name, notes: r.data || [] }))),
    ]);
    const classNotes = classNotesRes.data || [];
    const studentsWithNotes = studentNotesRes.filter((s) => s.notes.length > 0);
    const className = classDetails?.name || '';
    let html = `<!DOCTYPE html><html><head><title>All Notes — ${className}</title></head>
      <body style="font-family:Arial,sans-serif;padding:32px;max-width:760px;margin:0 auto;color:#1f2937;">
        <h1 style="border-bottom:2px solid #1a56db;padding-bottom:8px;color:#1a56db;margin-bottom:4px;">${className} — All Notes</h1>
        <p style="color:#999;font-size:11px;margin-bottom:28px;">Printed: ${new Date().toLocaleString('en-IE', { timeZone: 'Europe/Dublin' })}</p>`;
    if (classNotes.length > 0) {
      html += `<h2 style="color:#333;margin-top:0;margin-bottom:12px;">Class Notes</h2>`;
      html += classNotes.map((n) => formatNote(n, teachers)).join('');
    }
    if (studentsWithNotes.length > 0) {
      html += `<h2 style="color:#333;margin-top:28px;margin-bottom:12px;">Student Notes</h2>`;
      studentsWithNotes.forEach((s) => {
        html += `<h3 style="margin-top:16px;margin-bottom:8px;color:#444;">${s.name}</h3>`;
        html += s.notes.map((n) => formatNote(n, teachers)).join('');
      });
    }
    if (classNotes.length === 0 && studentsWithNotes.length === 0) {
      html += `<p style="color:#999;text-align:center;margin-top:48px;">No notes found for this class.</p>`;
    }
    html += '</body></html>';
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => { printWindow.print(); printWindow.close(); }, 250);
  };

  return (
    <Row>
      <Col>
        <div className="table-responsive-wrapper">
          <Row className="mb-2 align-items-center justify-content-end">
            <Col className="col-auto" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <div style={hasClassNotes ? { display: 'flex', flexDirection: 'column', alignItems: 'center', border: '2px solid #1a56db', borderRadius: '8px', padding: '4px 8px', backgroundColor: '#eef2ff', gap: '2px' } : { display: 'flex', flexDirection: 'column', alignItems: 'center', border: '2px solid #9ca3af', borderRadius: '8px', padding: '4px 8px', backgroundColor: '#f3f4f6', gap: '2px' }}>
                <NoteModal entityName={classDetails?.name} elementtype="class" elementid={classDetails.id} noteType={noteType} filterByNoteType={noteType === "ClassroomObservation"} teacherid={teacherid} teachers={teachers || []} onSuccess={fetchClassNotes} />
                <span style={{ fontSize: '10px', color: hasClassNotes ? '#1a56db' : '#6b7280', fontWeight: '600', lineHeight: 1 }}>Add/View a Classroom Notes</span>
              </div>
            </Col>
          </Row>
          <Row className="mb-3 filter-row">
            <Col>
              <div className="float-left-container">
                <label className="label-style">Show only:</label>
                <input type="radio" id="all" name="filter" value="all" className="radio-button-style input-margin" checked={selectedFilter === "all"} onChange={handleFilterChange} />
                <label htmlFor="all" className="label-style">All</label>
                <input type="radio" id="setOnly" name="filter" value="setOnly" className="radio-button-style input-margin" checked={selectedFilter === "setOnly"} onChange={handleFilterChange} />
                <label htmlFor="setOnly" className="label-style">Watchlist only</label>
                <input type="radio" title="Based on latest assessment score available" id="atRisk0to20" name="filter" value="atRisk0to20" className="radio-button-style input-margin" checked={selectedFilter === "atRisk0to20"} onChange={handleFilterChange} />
                <label htmlFor="atRisk0to20" className="radio-label radio-label-red label-style">At risk 0-20%</label>
                <input type="radio" title="Based on latest assessment score available" id="atRisk21to40" name="filter" value="atRisk21to40" className="radio-button-style input-margin" checked={selectedFilter === "atRisk21to40"} onChange={handleFilterChange} />
                <label htmlFor="atRisk21to40" className="radio-label radio-label-yellow label-style">21-40%</label>
              </div>
            </Col>
          </Row>
          <div className="table-responsive-wrapper">
            <Table className="custom-table handover-score-table">
              <thead>
                <tr>
                  <th className="table-header-cell" onClick={() => handleSortChange("name")}>
                    <div className="header-content">
                      <span>Name</span>
                      <img className="sort-icon" src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"} alt="Sort" />
                    </div>
                  </th>
                  <th className="table-header-cell">
                    <div className="header-content"><span>Notes</span></div>
                  </th>
                  {/* <th className="table-header-cell" onClick={() => handleSortChange("readingScore")}>
                    <div className="header-content">
                      Overall Score
                      <img className="sort-icon" src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"} alt="Sort" />
                    </div>
                  </th> */}
                  <th className="table-header-cell" style={{ width: '50px', backgroundColor: '#eef2ff'}}>
                    <div className="header-content"><span>Base</span></div>
                  </th>
                  <th className="table-header-cell" style={{ width: '50px', backgroundColor: '#eef2ff' }}>
                    <div className="header-content"><span>Mid</span></div>
                  </th>
                  <th className="table-header-cell" style={{ width: '50px', backgroundColor: '#eef2ff'}}>
                    <div className="header-content"><span>EOY</span></div>
                  </th>
                  {dummyHeaderArray.map((header, index) => (
                    <th key={index} className="table-header-cell">
                      <div className="header-content">{header}</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sortedData
                  .filter((student) => {
                    if (selectedFilter === "all") return true;
                    const latestScore = getLatestIndividualScore(student);
                    if (selectedFilter === "atRisk0to20") return latestScore !== null && latestScore <= 20;
                    if (selectedFilter === "atRisk21to40") return latestScore !== null && latestScore > 20 && latestScore <= 40;
                    if (selectedFilter === "setOnly") return watchlistStatuses[student.id] === true || student.sen === true;
                    return true;
                  })
                  .map((student) => (
                    <HandoverTableRow
                      additionalRoles={additionalRoles}
                      key={student.id}
                      student={student}
                      setStudents={setStudents}
                      teacherid={teacherid}
                      classId={classId}
                      currentStudentId={currentStudentId}
                      setCurrentStudentId={setCurrentStudentId}
                      dummyHeaderArray={dummyHeaderArray}
                      saveClicked={saveClicked}
                      getReadingScoreClass={getReadingScoreClass}
                      handleSaveChanges={handleSaveChanges}
                      handleShowLiteracyModal={handleShowLiteracyModal}
                      handleShowReadingScoreModal={handleShowReadingScoreModal}
                      handleShowEalModal={handleShowEalModal}
                      handleShowSetModal={handleShowESetModal}
                      handleShowAttendanceAffectingScoresModal={handleShowAttendanceAffectingScoresModal}
                      handleShowAdditionalNeedsModal={handleShowAdditionalNeedsModal}
                      handleShowSupportPlanModal={handleShowSupportPlanModal}
                      handleShowConfirmationModalEAL={handleShowConfirmationModalEAL}
                      handleShowConfirmationModalSET={handleShowConfirmationModalSET}
                      handleShowConfirmationModalAttendance={handleShowConfirmationModalAttendance}
                      readingScoreNotes={readingScoreNotes}
                      setReadingScoreNotes={setReadingScoreNotes}
                      literacyObservations={literacyObservations}
                      additionalNeeds={additionalNeeds}
                      supportPlan={supportPlan}
                      eal={eal}
                      set={set}
                      attendanceAffectingScores={attendanceAffectingScores}
                      setSortedData={setSortedData}
                      sortCriteria={sortCriteria}
                      sortStudents={sortStudents}
                      teachers={teachers || []}
                      getReport={getReport}
                      upsertReport={upsertReport}
                      onSenToggle={handleSenToggle}
                      watchlistStatuses={watchlistStatuses}
                      noteType={noteType}
                      ealManagedByReport={ealManagedByReport}
                    />
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
        <LiteracyObservationsModal
          show={showLiteracyModal}
          handleClose={handleCloseLiteracyModal}
          studentName={currentStudentName}
          literacyObservations={literacyObservations}
          setLiteracyObservations={setLiteracyObservations}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          getReport={getReport}
          upsertReport={upsertReport}
          onSaveSuccess={handleSaveSuccess}
        />
        <ReadingScoreNotesModal
          show={showReadingScoreModal}
          handleClose={handleCloseReadingScoreModal}
          studentName={currentStudentName}
          readingScoreNotes={readingScoreNotes}
          setReadingScoreNotes={setReadingScoreNotes}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          setSaveClicked={setSaveClicked}
          getReport={getReport}
          upsertReport={upsertReport}
          onSaveSuccess={handleSaveSuccess}
        />
        <AdditionalNeedsModal
          show={showAdditionalNeedsModal}
          handleClose={handleCloseAdditionalNeedsModal}
          studentName={currentStudentName}
          additionalNeeds={additionalNeeds}
          setAdditionalNeeds={setAdditionalNeeds}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          getReport={getReport}
          upsertReport={upsertReport}
          onSaveSuccess={handleSaveSuccess}
        />
        <SupportPlanModal
          show={showSupportPlanModal}
          handleClose={handleCloseSupportPlanModal}
          studentName={currentStudentName}
          supportPlan={supportPlan}
          setSupportPlan={setSupportPlan}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          getReport={getReport}
          upsertReport={upsertReport}
          onSaveSuccess={handleSaveSuccess}
        />
        <ConfirmationModal
          show={showConfirmationModal}
          handleClose={handleCloseConfirmationModal}
          studentName={currentStudentName}
          handleConfirmChange={handleConfirmChange}
          handleSaveChanges={handleSaveChanges}
          teacherid={teacherid}
        />
        <SetEalModal
          show={showEalModal}
          handleClose={handleCloseEalModal}
          studentName={currentStudentName}
          eal={eal}
          setEal={setEal}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
        />
        <SetSetModal
          show={showSetModal}
          handleClose={handleCloseSetModal}
          studentName={currentStudentName}
          set={set}
          setSet={setSet}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
        />
        <SetAttendanceAffectingScoresModal
          show={showAttendanceAffectingScoresModal}
          handleClose={handleCloseAttendanceAffectingScoresModal}
          studentName={currentStudentName}
          attendanceAffectingScores={attendanceAffectingScores}
          setAttendanceAffectingScores={setAttendanceAffectingScores}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
        />
        {showWatchlistModal && (
          <SenWatchlistModal
            show={showWatchlistModal}
            onHide={() => setShowWatchlistModal(false)}
            student={watchlistModalStudent}
            action={watchlistModalAction}
            teacherid={teacherid}
            onSuccess={handleWatchlistSuccess}
            teachers={teachers || []}
          />
        )}
      </Col>
    </Row>
  );
}

export default HandoverClassTable;
